"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
exports["default"] = void 0;

var _apiMethods = _interopRequireDefault(require("../apiMethods"));

var _config = _interopRequireDefault(require("./config"));

var _actions = require("./actions");

Object.keys(_actions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _actions[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Stadium =
/*#__PURE__*/
function () {
  function Stadium() {
    _classCallCheck(this, Stadium);
  }

  _createClass(Stadium, null, [{
    key: "getPosStands",
    value: function getPosStands(organizationName) {
      var request = _objectSpread({
        url: "pos/stands?organization_name=".concat(organizationName)
      }, _config["default"], {}, Stadium.config);

      return _apiMethods["default"].get(request);
    }
  }, {
    key: "getKioskStands",
    value: function getKioskStands(organizationName, venueUuid) {
      var serviceType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var serviceTypesQuery = "service_types[]=".concat(serviceType || Kiosk);
      var params = "organization_name=".concat(organizationName, "&venue_uuid=").concat(venueUuid, "&").concat(serviceTypesQuery);
      params += '&product_types[]=Food&product_types[]=Merchandise';

      var request = _objectSpread({
        url: "kiosk/v2/stands?".concat(params)
      }, _config["default"], {}, Stadium.config);

      return _apiMethods["default"].get(request);
    }
  }, {
    key: "getMenu",
    value: function getMenu(menuUuid, organizationName) {
      var request = _objectSpread({
        url: "api/v2/menu/".concat(menuUuid, "?organization_name=").concat(organizationName)
      }, _config["default"], {}, Stadium.config);

      return _apiMethods["default"].get(request);
    }
  }, {
    key: "getPosMenu",
    value: function getPosMenu(menuUuid, organizationName) {
      var request = _objectSpread({
        url: "pos/menus/".concat(menuUuid, "?organization_name=").concat(organizationName)
      }, _config["default"], {}, Stadium.config);

      return _apiMethods["default"].get(request);
    }
  }, {
    key: "createPosOrder",
    value: function createPosOrder() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var request = _objectSpread({
        url: 'pos/orders',
        data: params
      }, _config["default"], {}, Stadium.config);

      return _apiMethods["default"].post(request);
    }
  }, {
    key: "updatePosOrder",
    value: function updatePosOrder(uuid) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var request = _objectSpread({
        url: "pos/orders/".concat(uuid),
        data: params
      }, _config["default"], {}, Stadium.config);

      return _apiMethods["default"].put(request);
    }
  }, {
    key: "getConfigs",
    value: function getConfigs() {
      var request = _objectSpread({
        url: '/api/v1/app_device_configurations'
      }, _config["default"], {}, Stadium.config);

      return _apiMethods["default"].get(request);
    }
  }, {
    key: "getConfig",
    value: function getConfig(id) {
      var url = "/api/v1/app_device_configurations";
      if (id !== undefined) url = "".concat(url, "/").concat(id, "?uuid=").concat(id);

      var request = _objectSpread({
        url: url
      }, _config["default"], {}, Stadium.config);

      return _apiMethods["default"].get(request);
    }
  }, {
    key: "createConfig",
    value: function createConfig() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var request = _objectSpread({
        url: '/api/v1/app_device_configurations',
        data: params
      }, _config["default"], {}, Stadium.config);

      return _apiMethods["default"].post(request);
    }
  }, {
    key: "updateConfig",
    value: function updateConfig() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var request = _objectSpread({
        url: "/api/v1/app_device_configurations?uuid=".concat(params.uuid),
        data: params
      }, _config["default"], {}, Stadium.config);

      return _apiMethods["default"].put(request);
    }
  }]);

  return Stadium;
}();

exports["default"] = Stadium;

_defineProperty(Stadium, "config", {});